var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{staticClass:"b-crumb",class:_vm.noMb ? 'no-mb' : '',attrs:{"separator":">"}},_vm._l((_vm.list),function(item,idx){return _c('BreadcrumbItem',{key:idx,attrs:{"to":item.url}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }